import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import pullAt from 'lodash/pullAt';
export default {
  name: 'NiotaClassicDevicetypesPacketParserCalculation',
  mixins: [formMixin, parserTypesMixin],
  props: {
    calculateElements: {
      type: Array,
      required: false,
      default: () => []
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      calculateElementsInternal: []
    };
  },
  watch: {
    calculateElements: {
      handler: function (val) {
        const clonedPropCalculateElements = cloneDeep(val);
        this.calculateElementsInternal = clonedPropCalculateElements;
        if (clonedPropCalculateElements.length === 0) {
          this.addCalculateElement(0);
        }
      },
      immediate: true
    }
  },
  methods: {
    emitChanges() {
      const clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      this.$emit('config-updated', clonedCalculateElements);
    },
    requiredRuleForVariable(cElement) {
      return v => {
        const bothEmpty = !cElement.formula && !cElement.target;
        if (bothEmpty) {
          return true;
        }
        return this.requiredRule[0](v);
      };
    },
    parserTargetNameRule(cElement) {
      return v => {
        const bothEmpty = !cElement.formula && !cElement.target;
        if (bothEmpty) {
          return true;
        }
        if (!v) {
          return this.$i18n_t('Common.fieldRequired');
        }
        return /^[a-zA-Z0-9_\\.]+$/.exec(v) !== null || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variableNameRule');
      };
    },
    addCalculateElement(index) {
      const clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      clonedCalculateElements.splice(index + 1, 0, {
        target: '',
        formula: ''
      });
      this.calculateElementsInternal = clonedCalculateElements;
    },
    removeCalculateElement(index) {
      const clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      pullAt(clonedCalculateElements, [index]);
      this.calculateElementsInternal = clonedCalculateElements;
      this.emitChanges();
    },
    revalidateForm() {
      this.$emit('validate-form');
    },
    onInputsChanged() {
      this.revalidateForm();
      this.emitChanges();
    }
  }
};